import {
  Component,
  HostBinding,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { allAnimation } from 'ngx-rx-modal';

import { ROUTE_LOADING_TOKEN } from './route-loading.model';

// Alan:the reference:
// http://stackoverflow.com/questions/37069609/show-loading-screen-when-navigating-between-routes-in-angular-2
@Component({
  selector: 'ngx-route-loading',
  templateUrl: './route-loading.component.html',
  styleUrls: ['./route-loading.component.scss'],
  animations: [allAnimation],
  standalone: true,
})
export class RouteLoadingComponent {
  private _sanitizer = inject(DomSanitizer);
  private _innerContent = inject<string>(ROUTE_LOADING_TOKEN);
  @HostBinding('class') className =
    'flex justify-center items-center fixed w-full h-full top-0 left-0 pointer-events-auto z-[5000]';
  @HostBinding('@animate') _state = 'fadeIn';

  get content() {
    return this._sanitizer.bypassSecurityTrustHtml(this._innerContent);
  }
}
